/**
 * Badge ikon aplikasi (PWA) — Badging API.
 * Menampilkan jumlah notifikasi belum dibaca pada ikon aplikasi yang sudah
 * diinstal (Android/Chrome, iOS 16.4+, Edge). Di browser yang tidak
 * mendukung (mis. Firefox desktop), pemanggilan ini diabaikan dengan aman.
 */
type BadgingNavigator = Navigator & {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

/** Set/bersihkan badge ikon aplikasi sesuai jumlah notifikasi belum dibaca. */
export function syncAppBadge(count: number): void {
  if (typeof navigator === "undefined") return;
  const nav = navigator as BadgingNavigator;
  try {
    if (count > 0) {
      void nav.setAppBadge?.(count)?.catch(() => undefined);
    } else {
      void nav.clearAppBadge?.()?.catch(() => undefined);
    }
  } catch {
    // API tidak tersedia atau diblokir — abaikan tanpa mengganggu UI.
  }
}
